<template>
  <el-dialog title="派单" :visible.sync="visible" width="500px" center>
    <el-form :model="dispatchForm" :rules="rules" ref="dispatchForm" label-width="100px">
      <el-form-item label="选择师傅" prop="engineerId">
        <el-select
          v-model="dispatchForm.engineerId"
          placeholder="请选择师傅"
          filterable
          style="width: 100%"
          :loading="fetchingEngineers"
        >
          <el-option
            v-for="item in engineerOptions"
            :key="item.id"
            :label="item.name + ' (' + item.phone + ')'"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer" style="padding-bottom: 20px;">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="handleConfirm" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DispatchOrderDialog',
  data() {
    return {
      visible: false,
      loading: false,
      fetchingEngineers: false,
      engineerOptions: [],
      dispatchForm: {
        orderNum: '',
        engineerId: ''
      },
      rules: {
        engineerId: [
          { required: true, message: '请选择师傅', trigger: 'change' }
        ]
      }
    };
  },
  methods: {
    open(row) {
      this.dispatchForm.orderNum = row.orderNum;
      this.dispatchForm.engineerId = '';
      this.visible = true;
      this.getEngineerList(row.partnershipId);
      this.$nextTick(() => {
        this.$refs.dispatchForm.clearValidate();
      });
    },
    // 获取师傅列表
    getEngineerList(partnershipId) {
      this.fetchingEngineers = true;
      const params = {
        spids: "",
        accountName: "",
        name: "",
        organization: partnershipId,
        idNumber: "",
        phone: "",
        pageSize: 1000,
        pageNum: 1,
        approved: true,
        provinceCode: "",
        cityCode: "",
        districtCode: ""
      };
      this.HttpService.post('/autoapp-default-server-recovery/api/tbl-recycel-engineer/page', params)
        .then(res => {
          if (res.statusCode === 200) {
            this.engineerOptions = res.data.records || [];
          }
        })
        .finally(() => {
          this.fetchingEngineers = false;
        });
    },
    handleConfirm() {
      this.$refs.dispatchForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.HttpService.post('/autoapp-default-server-recovery/api/self-recycle/dispatch', this.dispatchForm)
            .then(res => {
              if (res.statusCode === 200) {
                this.$message.success('派单成功');
                this.visible = false;
                this.$emit('success');
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/order/components/DispatchOrderDialog.vue